"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Color;
(function (Color) {
    Color["Positive"] = "u-fill-pos";
    Color["Negative"] = "u-fill-neg";
    Color["Warning"] = "u-fill-warn";
})(Color || (Color = {}));
;
var TextAlign;
(function (TextAlign) {
    TextAlign["Left"] = "u-justify-content-start";
    TextAlign["Right"] = "u-justify-content-end";
})(TextAlign || (TextAlign = {}));
exports.Alert = function (props) {
    var classes = __spreadArrays([
        'c-alert',
        props.color,
        props.textAlign
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
exports.AlertText = function (props) {
    var classes = __spreadArrays([
        'c-alert__text'
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
exports.Alert.Color = Color;
exports.Alert.Text = exports.AlertText;
exports.Alert.TextAlign = TextAlign;
//# sourceMappingURL=Alert.js.map